import { defineStore } from 'pinia';
import { uid } from 'quasar';
import { LocalStorage } from 'quasar';
import type { dynamicObj } from 'src/pages/assets';
import { autoAccountingApiService } from 'src/services';
import { releaseRequest } from 'src/types';

export const useAutoAccountingListStore = defineStore('auto_accounting_list', {
  state: () => ({
    total_records: 0,
    records: [] as dynamicObj,
    record: {} as dynamicObj,
    processing: false,
    current_page: 1,
    total_pages: 0,
    offset: 0,
    page_size: 10,
  }),
  getters: {},
  actions: {
    async getDashboardData() {
      const data = {
        keyword: '',
        org_id: '',
        sub_org_id: '',
        filters: '',
        order_by: '',
        skip: this.offset,
        limit: this.page_size,
      };

      const response = await autoAccountingApiService.getAll(data);
      if (response?.success == false) {
        throw response;
      }

      this.records = response.documents;
      this.total_records = response.overview['all-invoices'];
      this.setTotalPages();
      if (!Array.isArray(this.records) || this.records.length == 0) {
        return;
      }
      this.record = this.records[0];
    },

    resetPagination() {
      this.total_pages = 0;
      this.current_page = 1;
    },

    setTotalPages() {
      this.total_pages = Math.ceil(this.total_records / this.page_size);
    },

    calculateOffset() {
      this.offset = this.page_size * (this.current_page - 1);
    },
  },
});
